module.exports = __webpack_public_path__ + "static/media/dashboard.612e23be.svg";